'use strict';

const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);

/** Shared wire validation. Unknown extension fields remain available to custom backends. */
function validateChatRequest(value) {
  if (!record(value)) return 'body must be an object';
  if (value.message !== undefined && typeof value.message !== 'string')
    return 'message must be text';
  for (const key of ['clientMessageId', 'threadId', 'sessionId']) {
    if (
      value[key] !== undefined &&
      value[key] !== null &&
      (typeof value[key] !== 'string' || value[key].length > 256)
    )
      return `${key} must be a string of at most 256 characters`;
  }
  if (value.stream !== undefined && typeof value.stream !== 'boolean')
    return 'stream must be boolean';
  if (value.meta !== undefined && !record(value.meta)) return 'meta must be an object';
  if (value.attachments !== undefined && !Array.isArray(value.attachments))
    return 'attachments must be an array';
  return null;
}

function isChatEvent(value) {
  if (!record(value)) return false;
  const type = value.type;
  if (type === 'text_delta' || value.delta?.text !== undefined)
    return typeof (value.delta?.text ?? value.text ?? '') === 'string';
  if (type === 'text_replace' || type === 'thinking')
    return value.text === undefined || typeof value.text === 'string';
  if (type === 'thread') return typeof value.threadId === 'string' && !!value.threadId;
  if (type === 'message_id') return typeof value.messageId === 'string' && !!value.messageId;
  if (type === 'redirect') return typeof value.url === 'string';
  if (['product_cards', 'order_cards', 'card', 'buttons', 'form'].includes(type))
    return record(value.content || value.richContent || value.payload);
  if (type === 'tool_call')
    return (
      (value.arguments === undefined || record(value.arguments)) &&
      (value.args === undefined || record(value.args))
    );
  if (type === 'tool_result') return typeof value.id === 'string';
  return ['citation', 'escalated', 'outcome', 'agentic_outcome', 'error'].includes(type);
}

module.exports = { validateChatRequest, isChatEvent };
